import { IServicePeriods } from '../types';

interface ISyncPeriodIdParams {
  periodIds: number[];
  periods: IServicePeriods;
  selectedPeriodId: number | null;
}

export function syncPeriodId(params: ISyncPeriodIdParams): number | null {
  const { periodIds, periods, selectedPeriodId } = params;
  const firstPeriodId = periodIds[0] || null;

  if (selectedPeriodId && periods[selectedPeriodId]) {
    return selectedPeriodId;
  }

  return firstPeriodId;
}
